// import React, {memo} from "react";
import { useNavigate } from "react-router-dom";
import NumberFormat from "react-number-format";
import { TextField } from "@mui/material";

import {Button} from "@mui/material";
// import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import moment from 'moment';



const TransactionView = ({transaction}) => {
    const navigate = useNavigate()


    return(
        <section className="dashboard-form">
            <section className="dashboard-form" style={{ display: 'flex', gap: '20px' }}>
                <div style={{ flex: '60%' }}>
                    <form noValidate autoComplete="off" >
                        <div className="grouped-fields-light">
                            <TextField className="custom-input"
                                label="Reference"
                                variant="outlined" 
                            fullWidth
                            defaultValue = {transaction.reference}
                            InputProps={{ readOnly: true }}
                        />
                        {transaction.doc_ref &&
                        <TextField className="custom-input"
                            label="Document Ref"
                            variant="outlined" 
                            fullWidth
                            defaultValue = {transaction.doc_ref}
                            InputProps={{ readOnly: true }}


                        />
                        }
                        <TextField className="custom-input"
                            label="Date"
                            variant="outlined" 
                            fullWidth
                            // defaultValue = {transaction.date}
                            defaultValue={moment(transaction.date).format('YYYY-MM-DD HH:mm')}
                            InputProps={{ readOnly: true }}
                        />

                        <TextField className="custom-input"
                            label="Account"
                            variant="outlined" 
                            fullWidth
                            // value = {transaction.account_name}
                            defaultValue = {transaction.account_name}
                            InputProps={{ readOnly: true }}
                        />

                        <div className="two-columns">
                            <NumberFormat 
                                className="custom-input"
                                fullWidth
                                label="Amount" 
                                variant="outlined" 
                                customInput={TextField}
                                thousandSeparator={true} 
                                defaultValue = {transaction.amount}
                                InputProps={{ readOnly: true }}

                            />
                            <TextField className="custom-input"
                                label="Entry Type"
                                variant="outlined" 
                                fullWidth
                                defaultValue = {transaction.entry_type}
                                InputProps={{ readOnly: true }}
                            />
                        </div>

                        <TextField className="custom-input"
                            label="Description"
                            variant="outlined" 
                            fullWidth
                            defaultValue = {transaction.description}
                            InputProps={{ readOnly: true }}

                        />
                        <TextField className="custom-input"
                            label="Memo"
                            variant="outlined" 
                            fullWidth
                            multiline
                            rows={2}
                            defaultValue = {transaction.memo}
                            InputProps={{ readOnly: true }}
                        />
                    
                    </div>
                    <div className="button-border-top">
                        <Button
                            onClick={()=>navigate("/dashboard/transactions")}
                            variant="outlined" 
                            size="small"
                            startIcon={<ArrowBackIcon />}
                        >
                            Back
                        </Button>

                        {/* {transaction.type_code==="010" &&
                        <Button
                            // id="AddRowButton"
                            onClick={() => navigate('/dashboard/invoicereport/',{state:{reference:transaction.reference}})}
                            variant="outlined" 
                            size="small"
                            startIcon={<InsertDriveFileIcon />}
                        >
                            PDF
                        </Button>
                        } */}

                    </div>
                </form>
                </div>

                <div style={{ flex: '40%' }}>
                    {/* <div className="grouped-fields-light"> */}
                    <div>
                        <TextField className="custom-input"
                            label="Posted By"
                            variant="outlined"
                            fullWidth
                            defaultValue={transaction.user_name}
                            InputProps={{ readOnly: true }}
                        />
                        <TextField className="custom-input"
                            label="Posted On"
                            variant="outlined"
                            fullWidth
                            defaultValue={moment(transaction.created_at).format('YYYY-MM-DD HH:mm')}
                            InputProps={{ readOnly: true }}
                        />
                        {transaction.last_modified_by && (
                            <>
                                <TextField className="custom-input"
                                    label="Last Modified By"
                                    variant="outlined"
                                    fullWidth
                                    defaultValue={transaction.last_modified_by}
                                    InputProps={{ readOnly: true }}
                                />
                                <TextField className="custom-input"
                                    label="Last Modified On"
                                    variant="outlined"
                                    fullWidth
                                    defaultValue={moment(transaction.last_modified_on).format('YYYY-MM-DD HH:mm')}
                                    InputProps={{ readOnly: true }}
                                />
                            </>
                        )}
                    </div>
                </div>
            </section>
        </section>
    )
}

export default TransactionView;